import React from 'react';
import styled from 'styled-components';

import { Display, Flex, Paragraph, Text } from '@rover/kibble/core';
import { Props as BoxProps } from '@rover/kibble/core/Box';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import { Props as FlexProps } from '@rover/kibble/core/Flex';
import { Props as ParagraphProps } from '@rover/kibble/core/Paragraph';
import { Props as TextProps } from '@rover/kibble/core/Text';
import { MQ } from '@rover/kibble/styles';
import UnorderedList from '@rover/react-lib/src/components/lists/UnorderedList/UnorderedList';

const StyledServiceTargetAudience = styled(Flex)`
  margin-top: 36px;
  width: 100%;
  padding: 0 16px;
  align-items: center;
  flex-direction: column;
  ${MQ.SM_UP.toString()} {
    margin-top: 48px;
    width: 80%;
    padding: 0;
  }
  ${MQ.MD_UP.toString()} {
    margin-bottom: 72px;
    width: 60%;
  }
  margin-bottom: 72px;
`;

const ServiceTargetAudience = (props: FlexProps): JSX.Element => {
  return <StyledServiceTargetAudience {...props}>{props.children}</StyledServiceTargetAudience>;
};

ServiceTargetAudience.Content = (props: ParagraphProps): JSX.Element => {
  return (
    <Paragraph size="200" textAlign="center" {...props}>
      {props.children}
    </Paragraph>
  );
};

ServiceTargetAudience.List = (props: BoxProps): JSX.Element => {
  return (
    <UnorderedList paddingLeft="4x" {...props}>
      {props.children}
    </UnorderedList>
  );
};

ServiceTargetAudience.Display = (props: DisplayProps): JSX.Element => {
  return (
    <Display size="500" responsive={false} as="h3" textAlign="center" {...props}>
      {props.children}
    </Display>
  );
};

ServiceTargetAudience.ListItem = (props: TextProps): JSX.Element => {
  return (
    <Text size="200" {...props}>
      {props.children}
    </Text>
  );
};

export default ServiceTargetAudience;
